/**
 * Marcas que trabaja la tienda.
 *
 * Cada marca lleva a la busqueda por ese nombre: es una entrada mas al catalogo
 * y, de paso, cubre la busqueda por marca, que es como mucha gente del rubro
 * llega ("necesito una Makita").
 */
import { Link } from 'react-router-dom';

import { rutas } from '../../utilidades/rutas';

export interface TiraMarcasProps {
  marcas: string[];
}

export function TiraMarcas({ marcas }: TiraMarcasProps) {
  return (
    <ul className="tira-marcas">
      {marcas.map((marca) => (
        <li key={marca}>
          <Link className="marca-pil" to={rutas.busqueda(marca)}>
            {marca}
          </Link>
        </li>
      ))}
    </ul>
  );
}
